/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encode text to Base64 or decode Base64 back to text — with full Unicode support and an optional URL-safe variant. Everything runs in your browser.`)
};

const es_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica texto a Base64 o decodifica Base64 de nuevo a texto — con soporte completo para Unicode y una variante segura para URL opcional. Todo se ejecuta en tu navegador.`)
};

const de_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodiere Text zu Base64 oder dekodiere Base64 zurück in Text — mit vollständiger Unicode-Unterstützung und einer optionalen URL-sicheren Variante. Alles läuft in deinem Browser.`)
};

const nl_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codeer tekst naar Base64 of decodeer Base64 terug naar tekst — met volledige Unicode-ondersteuning en een optionele URL-veilige variant. Alles werkt in uw browser.`)
};

const fr_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codez du texte en Base64 ou décodez Base64 en texte — avec support Unicode complet et une variante sûre pour les URL en option. Tout s'exécute dans votre navigateur.`)
};

const it_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica il testo in Base64 o decodifica Base64 in testo, con supporto completo a Unicode e una variante URL-safe opzionale. Tutto viene eseguito nel tuo browser.`)
};

const pt_br2_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifique texto para Base64 ou decodifique Base64 de volta para texto — com suporte completo a Unicode e uma variante segura para URL opcional. Tudo é executado no seu navegador.`)
};

const pt_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifique texto para Base64 ou descodifique Base64 de volta para texto — com suporte completo a Unicode e uma variante segura para URL opcional. Tudo funciona no seu navegador.`)
};

const ja_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストをBase64にエンコードしたり、Base64をテキストに戻したりできます—完全なUnicode対応と、オプションのURL-safe形式に対応しています。すべてブラウザで実行されます。`)
};

const zh_b64_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将文本编码为 Base64，或将 Base64 解码回文本——完整支持 Unicode，并提供可选的 URL 安全变体。所有操作都在您的浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_intro", locale)
	if (locale === "en") return en_b64_intro(inputs)
	if (locale === "es") return es_b64_intro(inputs)
	if (locale === "de") return de_b64_intro(inputs)
	if (locale === "nl") return nl_b64_intro(inputs)
	if (locale === "fr") return fr_b64_intro(inputs)
	if (locale === "it") return it_b64_intro(inputs)
	if (locale === "pt-BR") return pt_br2_b64_intro(inputs)
	if (locale === "pt") return pt_b64_intro(inputs)
	if (locale === "ja") return ja_b64_intro(inputs)
	return zh_b64_intro(inputs)
};